import { Component, Input, inject } from "@angular/core"
import { MatDialog } from "@angular/material/dialog"
import { MatIcon } from "@angular/material/icon"
import { MatTooltip } from "@angular/material/tooltip"
import { SuperiorEvaluationData } from "src/app/models"
import { SuperiorEvaluationDialogComponent } from "./superior-evaluation-dialog.component"

@Component({
    selector: "valben-superior-evaluation-modal",
    standalone: true,
    template: `
        <button
            type="button"
            class="valben-row-action"
            [attr.aria-label]="tooltip"
            [matTooltip]="tooltip"
            (click)="open()">
            <mat-icon>{{ icon }}</mat-icon>
        </button>`,
    imports: [MatIcon, MatTooltip],
})
export class SuperiorEvaluationModalComponent {
    @Input() data!: SuperiorEvaluationData | null
    @Input() icon: string = "assignment_ind"
    @Input() tooltip: string = "Detalji"

    private readonly _dialog = inject(MatDialog)

    open(): void {
        this._dialog.open(SuperiorEvaluationDialogComponent, {
            data: this.data,
            width: "42rem",
            maxWidth: "calc(100vw - 2rem)",
        })
    }
}
